import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootStore from "./rootStore";

const store = createStore(rootStore, composeWithDevTools());

export default store;
